import { StrapiEntityData } from '../../@api/Strapi';
import { ProductSelectionResource } from '../../@products/ProductSelection/ProductSelection';
import { DefaultBlock } from '../../Block/Block';
import { ButtonResource } from '../../Button/Button';
import { Link } from '../../Link/Link';
import { Image, MediaResource } from '../../Media/Media';

export enum ImageDeviceTypeResource {
    mobile = 'Mobile',
    tablet = 'Tablet',
    laptop = 'Laptop',
    desktop = 'Desktop',
}

export interface ImageWithFormatsResource {
    id: number;
    image: MediaResource;
    size: ImageDeviceTypeResource;
}

export interface ProductCollectionMediaResource {
    id: number;
    image: ImageWithFormatsResource[];
    button: ButtonResource | null;
    buttonTextColor: string | null;
    buttonBackgroundColor: string | null;
}

export interface ProductCollectionResource extends StrapiEntityData {
    title: string;
    titleColor: string;
    media: ProductCollectionMediaResource[] | null;
    productSelection: ProductSelectionResource | null;
    button: ButtonResource | null;
}

export interface ProductCollectionMediaItem {
    id: string;
    image: Image;
    backgroundColor?: string;
    textColor?: string;
    link?: Link;
}

export interface ProductCollectionInterface extends DefaultBlock {
    title: string;
    titleColor: string;
    meilisearchProductListName: string;
    media: ProductCollectionMediaItem[];
    link?: Link;
}
